<template>
    <div class="tw-flex tw-items-center tw-content-center tw-h-full tw-w-full">
        <div class="form-success tw-text-center tw-ml-auto tw-w-full">
            <h2 class="tw-text-xl lg:tw-text-3xl tw-py-4 lg:tw-py-6 tw-font-bold">Participação submetida com sucesso!</h2>
            <p class="tw-text-sm lg:tw-text-base tw-mx-auto tw-pb-6">Obrigada pela sua participação.<br>Brevemente será contactado pela nossa equipa para validar a sua participação.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>

<style lang="scss">
@import '~@/assets/scss/partials/_variables.scss';
.form-success {
    h2 {
        color: $blue;
        font-family: 'Light';
    }

    p {
        width: 87.5%;
        color: $blue;
        font-family: 'Regular';
    }
}

</style>
